import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

const ease = [0.16, 1, 0.3, 1];

export default function Testimonials() {
    return (
        <section
            id="temoignages"
            data-testid="testimonials-section"
            className="bg-[#F4F2EE] py-24 md:py-32"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-8">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-[#DC2626]" />
                            <span className="overline">05 · Témoignages</span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1E3A5F] leading-[1.05]">
                            Ils nous ont fait <span className="italic">confiance.</span>
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.figure
                            key={t.id}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, delay: i * 0.1, ease }}
                            data-testid={`testimonial-${i}`}
                            className="bg-[#FDFBF7] p-10 md:p-12 flex flex-col h-full border border-[#E2E8F0]/80"
                        >
                            <Quote size={26} strokeWidth={1.2} className="text-[#DC2626] mb-8" />
                            <blockquote className="font-serif text-xl md:text-2xl text-[#1E3A5F] leading-snug flex-1 italic">
                                « {t.quote} »
                            </blockquote>
                            <figcaption className="mt-10 pt-6 border-t border-[#E2E8F0]">
                                <div className="font-medium text-[#1E3A5F]">{t.name}</div>
                                <div className="text-sm text-[#64748B] mt-1">
                                    {t.project} · {t.location}
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
